module.exports = __webpack_public_path__ + "static/media/wave-large-icon.8e2858e9.png";